// Libs
import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router';
import { BrowserRouter as Router } from 'react-router-dom';
import { hot } from 'react-hot-loader';

import getStore from '../../app/store/getStore';

// Components
import App from './App';
import Login from '../routes/Login';
import { LoginQRCodeTest } from "../routes/Login/LoginQRCodeTest";
import MissingBankID from '../routes/MissingBankID';
import NotFound from '../../app/NotFound';
import AuthenticatedContainer from './AuthenticatedContainer';
import API from '../../app/lib/APIHelpers/API';
import cookies from 'cookies-js';
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';
import * as Swedish from '../../translations/Swedish.json';
const baseURL = __API_BASE_URL__;
function Root() {
  const fetchTranslations = async () => {
    let token = cookies.get("BEARER");
    if (token) {
      const [data, error] = await API.get(baseURL + "/public/translations", {
        headers: new Headers({
          authorization: `Bearer ${token}`,
        }),
      });
      return { data: data, error: error };
    } else {
      return { data: [], error: "Not logged in" }
    }
  };

  useEffect(() => {
    let isMounted = true;

    const initializeI18n = async (data) => {
      let resources;

      if (!data || data.length === 0) {
        resources = { sw: { translation: Swedish } };
      } else {
        resources = {
          sw: {
            translation: data.reduce(
              (translations, item) => ({ ...translations, [item.code]: item.value }),
              {}
            ),
          },
        };
      }

      await i18next.init({ resources, lng: "sw" });

      if (isMounted) {
        console.log("Updated:", i18next);
      }
    };

    // Initialize with empty data
    initializeI18n([]).catch(error => {
      if (isMounted) {
        console.error('Failed to initialize i18n:', error);
      }
    });

    fetchTranslations()
      .then(({ data, error }) => {
        if (isMounted) {
          if (error) {
            console.error('Failed to fetch translations:', error);
            initializeI18n([]);
          } else {
            initializeI18n(data);
          }
        }
      })
      .catch((error) => {
        if (isMounted) {
          console.error('Failed to fetch translations:', error);
          initializeI18n([]);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Provider store={getStore()}>
      <I18nextProvider i18n={i18next}>
        <App>
          <Router>
            <Switch>
              <Route exact path="/public/qr-code-test" component={LoginQRCodeTest} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/missing-bankid" component={MissingBankID} />
              <Route
                path="/"
                component={AuthenticatedContainer}
              />
              <Route component={NotFound} />
            </Switch>
          </Router>
        </App>
      </I18nextProvider>
    </Provider>
  );
}

export default hot(module)(Root);
